module.exports = __webpack_public_path__ + "img/widget_018.ba0b0f9a.png";